import "./App.css";
import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import FrontPage from "./components/FrontPage";
import LayoutGuest from "./components/LayoutGuest";
import Profile from "./components/Profile";
import BackgroundVideo from "./components/BackgroundVideo";
import PackPage from "./components/PackPage";
import Inventory from "./components/Inventory";
import EventPage from "./components/EventPage";
import Leaderboard from "./components/Leaderboard";
import Events from "./components/Events";
import Market from "./components/Market";
import HowToPlay from "./components/HowToPlay/HowToPlay";
import TeamBuildingChallenge from "./components/TeamBuildingChallenge/TeamBuildingChallenge";
import EmailVerification from "./components/EmailVerification";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import ClutchPicks from "./components/ClutchPicks";
import League from "./components/League";
import LeagueInvite from "./components/LeagueInvite";
import Premium from "./components/Premium";
import PaymentStatus from "./components/PaymentStatus";
import WelcomeTutorial from "./components/WelcomeTutorial";
import AnalyticsTracker from "./components/AnalyticsTracker";
import CookieConsent from "./components/CookieConsent";

// Wrapper component to handle protected inventory route
const ProtectedInventory = () => {
  const { userNumber } = useParams();
  const { user } = useAuthContext();

  // Check if the current user is trying to access their own inventory
  if (user && user.userNumber === parseInt(userNumber)) {
    return <Navigate to={`/inventory`} />;
  } else {
    return <Profile />;
  }
};

function App() {
  const { user, loading } = useAuthContext();
  const [showTutorial, setShowTutorial] = useState(false);

  useEffect(() => {
    // Check if user is logged in and hasn't seen the tutorial
    if (user && user.hasSeenTutorial === false) {
      setShowTutorial(true);
    }
  }, [user]);

  const handleCloseTutorial = () => {
    setShowTutorial(false);
  };

  if (loading) {
    return (
      <div className="loader-overlay">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <AnalyticsTracker />
      <BackgroundVideo />
      {showTutorial && <WelcomeTutorial onClose={handleCloseTutorial} />}
      <div className="app-container">
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<FrontPage />} />
              {/*<Route path='login' element={<Welcome />} />
              <Route path='signup' element={<Welcome />} />*/}
              <Route path="packs" element={<PackPage />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="event/:event_id" element={<EventPage />} />
              <Route path="events" element={<Events />} />
              <Route path="market" element={<Market />} />
              <Route path="leaderboard" element={<Leaderboard />} />
              <Route
                path="profile"
                element={
                  user ? (
                    <Navigate to={`/profile/${user?.userNumber}`} />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route path="profile/:userNumber" element={<Profile />} />
              <Route
                path="profile/:userNumber/inventory"
                element={<ProtectedInventory />}
              />
              <Route
                path="profile/:userNumber/fantasy-teams"
                element={<Profile />}
              />
              <Route
                path="profile/:userNumber/achievements"
                element={<Profile />}
              />
              <Route
                path="profile/achievements"
                element={
                  <Navigate to={`/profile/${user?.userNumber}/achievements`} />
                }
              />
              <Route
                path="profile/fantasy-teams"
                element={
                  <Navigate to={`/profile/${user?.userNumber}/fantasy-teams`} />
                }
              />
              <Route path="howtoplay" element={<HowToPlay />} />
              <Route path="tbc" element={<TeamBuildingChallenge />} />
              <Route path="clutch-picks" element={<ClutchPicks />} />
              <Route path="/change-password" element={<ForgotPassword />} />
              <Route path="/league" element={<League />} />
              <Route path="/league/join/:inviteId" element={<LeagueInvite />} />
              <Route
                path="/forgot-password"
                element={!user ? <ForgotPassword /> : <Navigate to="/" />}
              />
              {/*<Route
                path="/premium"
                element={user ? <Premium /> : <Navigate to="/" />}
              />
              <Route
                path="/payment-status/:status"
                element={user ? <PaymentStatus /> : <Navigate to="/" />}
              />*/}
            </Route>
            {/* Public routes for email verification and password reset */}
            <Route
              path="/verify-email"
              element={!user ? <EmailVerification /> : <Navigate to="/" />}
            />
            <Route
              path="/reset-password"
              element={!user ? <ResetPassword /> : <Navigate to="/" />}
            />
          </Routes>
        </div>
      </div>
      <CookieConsent />
    </ThemeProvider>
  );
}

export default App;
